/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BookingPriceBandInput,
    BookingPriceBandInputFromJSON,
    BookingPriceBandInputFromJSONTyped,
    BookingPriceBandInputToJSON,
    CabinClassTypeCriteriaInput,
    CabinClassTypeCriteriaInputFromJSON,
    CabinClassTypeCriteriaInputFromJSONTyped,
    CabinClassTypeCriteriaInputToJSON,
    CharCriteriaInput,
    CharCriteriaInputFromJSON,
    CharCriteriaInputFromJSONTyped,
    CharCriteriaInputToJSON,
    CriteriaForBookingDateTimeInput,
    CriteriaForBookingDateTimeInputFromJSON,
    CriteriaForBookingDateTimeInputFromJSONTyped,
    CriteriaForBookingDateTimeInputToJSON,
    CriteriaForLocationInput,
    CriteriaForLocationInputFromJSON,
    CriteriaForLocationInputFromJSONTyped,
    CriteriaForLocationInputToJSON,
    CriteriaForRouteInput,
    CriteriaForRouteInputFromJSON,
    CriteriaForRouteInputFromJSONTyped,
    CriteriaForRouteInputToJSON,
    DateTimeCriteriaRangeInput,
    DateTimeCriteriaRangeInputFromJSON,
    DateTimeCriteriaRangeInputFromJSONTyped,
    DateTimeCriteriaRangeInputToJSON,
    FareTypeCriteriaInput,
    FareTypeCriteriaInputFromJSON,
    FareTypeCriteriaInputFromJSONTyped,
    FareTypeCriteriaInputToJSON,
    Int32CriteriaRangeInput,
    Int32CriteriaRangeInputFromJSON,
    Int32CriteriaRangeInputFromJSONTyped,
    Int32CriteriaRangeInputToJSON,
    JourneyTypeCriteriaInput,
    JourneyTypeCriteriaInputFromJSON,
    JourneyTypeCriteriaInputFromJSONTyped,
    JourneyTypeCriteriaInputToJSON,
    PriorityType,
    PriorityTypeFromJSON,
    PriorityTypeFromJSONTyped,
    PriorityTypeToJSON,
    StringCriteriaInput,
    StringCriteriaInputFromJSON,
    StringCriteriaInputFromJSONTyped,
    StringCriteriaInputToJSON,
    StringCriteriaRangeInput,
    StringCriteriaRangeInputFromJSON,
    StringCriteriaRangeInputFromJSONTyped,
    StringCriteriaRangeInputToJSON,
    SystemContextInput,
    SystemContextInputFromJSON,
    SystemContextInputFromJSONTyped,
    SystemContextInputToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateMarkupInput
 */
export interface CreateMarkupInput {
    /**
     * 
     * @type {Array<StringCriteriaInput>}
     * @memberof CreateMarkupInput
     */
    accountCodes?: Array<StringCriteriaInput> | null;
    /**
     * 
     * @type {Array<CharCriteriaInput>}
     * @memberof CreateMarkupInput
     */
    bookingClasses?: Array<CharCriteriaInput> | null;
    /**
     * 
     * @type {Array<CriteriaForBookingDateTimeInput>}
     * @memberof CreateMarkupInput
     */
    bookingDateTimes?: Array<CriteriaForBookingDateTimeInput> | null;
    /**
     * 
     * @type {Array<BookingPriceBandInput>}
     * @memberof CreateMarkupInput
     */
    bookingPriceBands?: Array<BookingPriceBandInput> | null;
    /**
     * 
     * @type {Array<CabinClassTypeCriteriaInput>}
     * @memberof CreateMarkupInput
     */
    cabinClasses?: Array<CabinClassTypeCriteriaInput> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMarkupInput
     */
    comment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMarkupInput
     */
    description?: string | null;
    /**
     * 
     * @type {Array<StringCriteriaInput>}
     * @memberof CreateMarkupInput
     */
    fareBasisCodes?: Array<StringCriteriaInput> | null;
    /**
     * 
     * @type {Array<FareTypeCriteriaInput>}
     * @memberof CreateMarkupInput
     */
    fareTypes?: Array<FareTypeCriteriaInput> | null;
    /**
     * 
     * @type {Array<StringCriteriaRangeInput>}
     * @memberof CreateMarkupInput
     */
    flightNumbers?: Array<StringCriteriaRangeInput> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMarkupInput
     */
    includeTax?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMarkupInput
     */
    isEnabled?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMarkupInput
     */
    isExclusionRule?: boolean | null;
    /**
     * 
     * @type {Array<JourneyTypeCriteriaInput>}
     * @memberof CreateMarkupInput
     */
    journeyTypes?: Array<JourneyTypeCriteriaInput> | null;
    /**
     * 
     * @type {Array<CriteriaForLocationInput>}
     * @memberof CreateMarkupInput
     */
    locations?: Array<CriteriaForLocationInput> | null;
    /**
     * 
     * @type {Array<StringCriteriaInput>}
     * @memberof CreateMarkupInput
     */
    marketingAirlines?: Array<StringCriteriaInput> | null;
    /**
     * 
     * @type {number}
     * @memberof CreateMarkupInput
     */
    markupAmount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateMarkupInput
     */
    markupPercentage?: number | null;
    /**
     * 
     * @type {Array<Int32CriteriaRangeInput>}
     * @memberof CreateMarkupInput
     */
    passengerAges?: Array<Int32CriteriaRangeInput> | null;
    /**
     * 
     * @type {PriorityType}
     * @memberof CreateMarkupInput
     */
    priority?: PriorityType;
    /**
     * 
     * @type {Array<CriteriaForRouteInput>}
     * @memberof CreateMarkupInput
     */
    routes?: Array<CriteriaForRouteInput> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateMarkupInput
     */
    suppliers?: Array<string> | null;
    /**
     * 
     * @type {SystemContextInput}
     * @memberof CreateMarkupInput
     */
    systemContext?: SystemContextInput;
    /**
     * 
     * @type {Array<StringCriteriaInput>}
     * @memberof CreateMarkupInput
     */
    ticketDesignators?: Array<StringCriteriaInput> | null;
    /**
     * 
     * @type {Array<DateTimeCriteriaRangeInput>}
     * @memberof CreateMarkupInput
     */
    travelDateTimes?: Array<DateTimeCriteriaRangeInput> | null;
}

export function CreateMarkupInputFromJSON(json: any): CreateMarkupInput {
    return CreateMarkupInputFromJSONTyped(json, false);
}

export function CreateMarkupInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMarkupInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accountCodes': !exists(json, 'accountCodes') ? undefined : (json['accountCodes'] === null ? null : (json['accountCodes'] as Array<any>).map(StringCriteriaInputFromJSON)),
        'bookingClasses': !exists(json, 'bookingClasses') ? undefined : (json['bookingClasses'] === null ? null : (json['bookingClasses'] as Array<any>).map(CharCriteriaInputFromJSON)),
        'bookingDateTimes': !exists(json, 'bookingDateTimes') ? undefined : (json['bookingDateTimes'] === null ? null : (json['bookingDateTimes'] as Array<any>).map(CriteriaForBookingDateTimeInputFromJSON)),
        'bookingPriceBands': !exists(json, 'bookingPriceBands') ? undefined : (json['bookingPriceBands'] === null ? null : (json['bookingPriceBands'] as Array<any>).map(BookingPriceBandInputFromJSON)),
        'cabinClasses': !exists(json, 'cabinClasses') ? undefined : (json['cabinClasses'] === null ? null : (json['cabinClasses'] as Array<any>).map(CabinClassTypeCriteriaInputFromJSON)),
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'fareBasisCodes': !exists(json, 'fareBasisCodes') ? undefined : (json['fareBasisCodes'] === null ? null : (json['fareBasisCodes'] as Array<any>).map(StringCriteriaInputFromJSON)),
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(FareTypeCriteriaInputFromJSON)),
        'flightNumbers': !exists(json, 'flightNumbers') ? undefined : (json['flightNumbers'] === null ? null : (json['flightNumbers'] as Array<any>).map(StringCriteriaRangeInputFromJSON)),
        'includeTax': !exists(json, 'includeTax') ? undefined : json['includeTax'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'isExclusionRule': !exists(json, 'isExclusionRule') ? undefined : json['isExclusionRule'],
        'journeyTypes': !exists(json, 'journeyTypes') ? undefined : (json['journeyTypes'] === null ? null : (json['journeyTypes'] as Array<any>).map(JourneyTypeCriteriaInputFromJSON)),
        'locations': !exists(json, 'locations') ? undefined : (json['locations'] === null ? null : (json['locations'] as Array<any>).map(CriteriaForLocationInputFromJSON)),
        'marketingAirlines': !exists(json, 'marketingAirlines') ? undefined : (json['marketingAirlines'] === null ? null : (json['marketingAirlines'] as Array<any>).map(StringCriteriaInputFromJSON)),
        'markupAmount': !exists(json, 'markupAmount') ? undefined : json['markupAmount'],
        'markupPercentage': !exists(json, 'markupPercentage') ? undefined : json['markupPercentage'],
        'passengerAges': !exists(json, 'passengerAges') ? undefined : (json['passengerAges'] === null ? null : (json['passengerAges'] as Array<any>).map(Int32CriteriaRangeInputFromJSON)),
        'priority': !exists(json, 'priority') ? undefined : PriorityTypeFromJSON(json['priority']),
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(CriteriaForRouteInputFromJSON)),
        'suppliers': !exists(json, 'suppliers') ? undefined : json['suppliers'],
        'systemContext': !exists(json, 'systemContext') ? undefined : SystemContextInputFromJSON(json['systemContext']),
        'ticketDesignators': !exists(json, 'ticketDesignators') ? undefined : (json['ticketDesignators'] === null ? null : (json['ticketDesignators'] as Array<any>).map(StringCriteriaInputFromJSON)),
        'travelDateTimes': !exists(json, 'travelDateTimes') ? undefined : (json['travelDateTimes'] === null ? null : (json['travelDateTimes'] as Array<any>).map(DateTimeCriteriaRangeInputFromJSON)),
    };
}

export function CreateMarkupInputToJSON(value?: CreateMarkupInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accountCodes': value.accountCodes === undefined ? undefined : (value.accountCodes === null ? null : (value.accountCodes as Array<any>).map(StringCriteriaInputToJSON)),
        'bookingClasses': value.bookingClasses === undefined ? undefined : (value.bookingClasses === null ? null : (value.bookingClasses as Array<any>).map(CharCriteriaInputToJSON)),
        'bookingDateTimes': value.bookingDateTimes === undefined ? undefined : (value.bookingDateTimes === null ? null : (value.bookingDateTimes as Array<any>).map(CriteriaForBookingDateTimeInputToJSON)),
        'bookingPriceBands': value.bookingPriceBands === undefined ? undefined : (value.bookingPriceBands === null ? null : (value.bookingPriceBands as Array<any>).map(BookingPriceBandInputToJSON)),
        'cabinClasses': value.cabinClasses === undefined ? undefined : (value.cabinClasses === null ? null : (value.cabinClasses as Array<any>).map(CabinClassTypeCriteriaInputToJSON)),
        'comment': value.comment,
        'description': value.description,
        'fareBasisCodes': value.fareBasisCodes === undefined ? undefined : (value.fareBasisCodes === null ? null : (value.fareBasisCodes as Array<any>).map(StringCriteriaInputToJSON)),
        'fareTypes': value.fareTypes === undefined ? undefined : (value.fareTypes === null ? null : (value.fareTypes as Array<any>).map(FareTypeCriteriaInputToJSON)),
        'flightNumbers': value.flightNumbers === undefined ? undefined : (value.flightNumbers === null ? null : (value.flightNumbers as Array<any>).map(StringCriteriaRangeInputToJSON)),
        'includeTax': value.includeTax,
        'isEnabled': value.isEnabled,
        'isExclusionRule': value.isExclusionRule,
        'journeyTypes': value.journeyTypes === undefined ? undefined : (value.journeyTypes === null ? null : (value.journeyTypes as Array<any>).map(JourneyTypeCriteriaInputToJSON)),
        'locations': value.locations === undefined ? undefined : (value.locations === null ? null : (value.locations as Array<any>).map(CriteriaForLocationInputToJSON)),
        'marketingAirlines': value.marketingAirlines === undefined ? undefined : (value.marketingAirlines === null ? null : (value.marketingAirlines as Array<any>).map(StringCriteriaInputToJSON)),
        'markupAmount': value.markupAmount,
        'markupPercentage': value.markupPercentage,
        'passengerAges': value.passengerAges === undefined ? undefined : (value.passengerAges === null ? null : (value.passengerAges as Array<any>).map(Int32CriteriaRangeInputToJSON)),
        'priority': PriorityTypeToJSON(value.priority),
        'routes': value.routes === undefined ? undefined : (value.routes === null ? null : (value.routes as Array<any>).map(CriteriaForRouteInputToJSON)),
        'suppliers': value.suppliers,
        'systemContext': SystemContextInputToJSON(value.systemContext),
        'ticketDesignators': value.ticketDesignators === undefined ? undefined : (value.ticketDesignators === null ? null : (value.ticketDesignators as Array<any>).map(StringCriteriaInputToJSON)),
        'travelDateTimes': value.travelDateTimes === undefined ? undefined : (value.travelDateTimes === null ? null : (value.travelDateTimes as Array<any>).map(DateTimeCriteriaRangeInputToJSON)),
    };
}


